<template>
  <div v-loading="moduleLoadingOne" class="sectionContainer">
    <div v-if="!moduleLoadingOne">
      <BaseTitleBox title="Seguimiento"
                    subtitle="Sigue el progreso de las rutas activas">
      </BaseTitleBox>
        <div class="content">
          <el-tabs :tab-position="tabPosition" style="height: 100%;">
            <el-tab-pane label="Seguimiento">
              <el-row :gutter="20" class="paddingContainer">
                <el-col :xs="24" :sm="24" :md="10" :lg=10>
                  <TracingActualProgress
                    v-loading="loadComponents"
                    setPadding="160"
                    :largeText="false"
                    :sectionName="enterpriseName"
                    :chartData="selectedResult"
                    :elementId="'progressChart'" />
                </el-col>
                <el-col :xs="24" :sm="24" :md="14" :lg="14">
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="Vehiculos atrasados" name="first">
                      <TracingDelayedTrucks
                        :title="false"
                        v-loading="loadComponents"
                        :sectionName="enterpriseName"
                        :byEnterprise="true"
                        :delayedTrucksTotalData="selectedResult"
                        @clickPatent="handlePatent"
                        class="paddingTop" />
                    </el-tab-pane>
                    <el-tab-pane label="Rutas de hoy" name="second">
                      <TracingRoutesTable
                        v-loading="loadRoutes"
                        :routes="routes"
                        @clickPatent="handlePatent"
                      />
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
              <el-row
                v-if="selectedPatent !== ''"
                :gutter="20"
                class="paddingRoute paddingContainer">
                <el-col :xs="24" :sm="24" :md="24" :lg=24>
                  <TracingEnterpriseSelectdRoute
                    :routeExists="routeDataVisible"
                    :load="loadSelectedRoute"
                    :route="routeData"
                    :patent="selectedPatent"/>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane class="fullTab" label="Administración">
              <el-tabs :tab-position="adminTab" style="height: 100%;">
                <el-tab-pane label="Conductores">
                  <el-col :xs="24" :sm="24" :md="24">
                    <TracingEnterpriseDrivers/>
                  </el-col>
                </el-tab-pane>
                <el-tab-pane label="Vehículos">
                  <el-col :xs="24" :sm="24" :md="24">
                    <TracingEnterpriseVehicles/>
                  </el-col>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import TracingEnterpriseDrivers from '../components/TracingEnterpriseDrivers.vue';
import TracingEnterpriseVehicles from '../components/TracingEnterpriseVehicles.vue';
import TracingDelayedTrucks from '../components/TracingDelayedTrucks.vue';
import TracingRoutesTable from '../components/TracingRoutesTable.vue';
import BaseTitleBox from '../components/BaseBoxTitle.vue';
import TracingActualProgress from '../components/TracingActualProgress.vue';
import TracingEnterpriseSelectdRoute from '../components/TracingEnterpriseSelectdRoute.vue';

export default {
  name: 'TracingEnterprise',
  components: {
    TracingEnterpriseSelectdRoute,
    TracingActualProgress,
    TracingEnterpriseDrivers,
    TracingEnterpriseVehicles,
    BaseTitleBox,
    TracingRoutesTable,
    TracingDelayedTrucks,
  },
  data() {
    return {
      moduleLoadingOne: false,
      tabPosition: 'left',
      adminTab: 'top',
      loadSelectedRoute: false,
      loadRoutes: false,
      selectedResult: [],
      loadComponents: false,
      enterpriseName: '',
      activeName: 'first',
      routes: [],
      routeData: {},
      selectedPatent: '',
      routeDataVisible: true,
    };
  },
  methods: {
    handlePatent(data) {
      this.selectedPatent = data;
      this.loadSelectedRoute = true;
      this.routeDataVisible = true;
      apiRequest({
        module: 'tracing',
        service: 'vehicle',
        params: {
          patent: this.selectedPatent.toUpperCase(),
        },
      }).then((result) => {
        this.routeData = result.data;
        this.loadSelectedRoute = false;
      }).catch(() => {
        this.routeDataVisible = false;
        this.loadSelectedRoute = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        });
      });
    },
    getMainData() {
      this.loadComponents = true;
      this.loadRoutes = true;
      const init = new Date();
      init.setHours(0, 0, 0, 0);
      const initTime = moment.utc(init).toISOString();
      const finish = init.setDate(init.getDate() + 1);
      const finishTime = moment.utc(finish).toISOString();
      apiRequest({
        module: 'tracing',
        service: 'get_tracing_data',
        pathparam: { id: '' },
        params: {
          time_init: initTime,
          time_end: finishTime,
        },
      }).then((result) => {
        this.selectedResult.pop();
        this.selectedResult.push(result.data);
        this.moduleLoadingOne = false;
        this.loadComponents = false;
      }).catch(() => {
        this.moduleLoadingOne = false;
        this.loadComponents = false;
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        }); */
      });
      apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: {
          limit: 1000,
        },
      }).then((result) => {
        this.routes.pop();
        this.routes.push(result.data);
        this.loadRoutes = false;
      }).catch(() => {
        this.loadRoutes = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        });
      });
    },
  },
  beforeMount() {
    this.getMainData();
  },
  created() {
    this.$options.interval = setInterval(() => {
      this.getMainData();
    }, 200000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
};
</script>

<style scoped>
  .sectionContainer.wrap {
    overflow: scroll !important;
  }
  .fullTab {
    padding-right: 1em;
  }
  .paddingContainer {
    padding: 0 2em;
    margin: 0 !important;
  }
  .paddingRoute {
    padding-top: 0.5em;
  }
  .content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 2em;
  }
  @media only screen and (min-width: 769px) {
    .fullTab {
      width: calc(100vw - 15em);
    }
  }
  @media only screen and (max-width: 768px) {
    .sectionContainer {
      width: 100vw;
      position: relative;
    }
  }
</style>
